// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"bkC94":[function(require,module,exports) {
require("b4645e5648523601").register(require("f89ef9bac72aa9ef").getBundleURL("dgt5F"), JSON.parse('["dgt5F","index.db3ace4e.js","jjakV","profile-picture-1.7495cca9.jpg","fKZXu","new_pfp.f412a206.png","bWHkh","resume_fall2024.2350a0e2.pdf","aKbmH","arrow_down.fbe43fd1.svg","2XEsA","arrow.6881dd4b.css","lyaVv","portalink_solar_system_example.2cd6b5b4.png","2XnF7","portalink.b7627d08.gif","8hCi1","village-gif.5abbfea4.gif","lbwkU","village.befd9f6b.png","lWvnn","painted-cube.1c2d5e2f.png"]'));

},{"b4645e5648523601":"fyJL2","f89ef9bac72aa9ef":"c7Tr5"}],"fyJL2":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"c7Tr5":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"8RSWf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "relative_root", ()=>relative_root);
parcelHelpers.export(exports, "MyElement", ()=>MyElement);
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _navbarTs = require("./components/navbar.ts");
var _footerTs = require("./components/footer.ts");
var _itemTs = require("./components/item.ts");
// ## TOP HALF IMAGE IMPORTS
// @ts-ignore
var _profilePicture1Jpg = require("url:./assets/profile-picture-1.jpg");
var _profilePicture1JpgDefault = parcelHelpers.interopDefault(_profilePicture1Jpg);
// @ts-ignore
var _newPfpPng = require("url:./assets/new_pfp.png");
var _newPfpPngDefault = parcelHelpers.interopDefault(_newPfpPng);
// @ts-ignore
var _resumeFall2024Pdf = require("url:./assets/resume_fall2024.pdf");
var _resumeFall2024PdfDefault = parcelHelpers.interopDefault(_resumeFall2024Pdf);
// @ts-ignore
var _arrowDownSvg = require("url:./assets/arrow_down.svg");
var _arrowDownSvgDefault = parcelHelpers.interopDefault(_arrowDownSvg);
// @ts-ignore
var _arrowCss = require("url:./style/arrow.css");
var _arrowCssDefault = parcelHelpers.interopDefault(_arrowCss);
// ## BOTTOM HALF IMAGE IMPORTS
var _itemPortalinkTs = require("./items-research/item-portalink.ts");
var _itemFilteredInkTs = require("./items-research/item-filtered-ink.ts");
var _itemProceduralPaintTs = require("./items-research/item-procedural-paint.ts");
var _globalTs = require("./style/global.ts");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const relative_root = "";
let MyElement = class MyElement extends (0, _lit.LitElement) {
    static get styles() {
        return [
            (0, _globalTs.GlobalCSS),
            (0, _lit.css)`:host {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        #header-container {
            display: flex;
            flex-direction: row;
            align-items: center;
        
            width: fit-content;
            margin-top: 4rem;
        }
        
        #header-container-left {
            display: flex;
            flex-direction: column;
        
            width: 32rem;
            margin-right: 4rem;
        }
        
        #header-container-right {
            position: relative;
            display: flex;
        
            width: 16rem;
            top: -10rem;
        }

        #header-profile-picture-1 {
            position: absolute;
            z-index: -10;
            width: 14rem;
            height: 18rem;
            object-fit: cover;
            filter: blur(0.5px);
        
            top: 2.5rem;
            left: 2.5rem;
        }
        
        #header-profile-picture-2 {
            position: absolute;
            width: 14rem;
            height: 18rem;
            object-fit: cover;
            border: 4px white solid;
            filter: blur(0.5px);
        }
            
        #selected-research-header {
            margin-top: 6rem;
            margin-bottom: 4rem;
        }
            
        `
        ];
    }
    render() {
        return (0, _lit.html)`
    <link rel="stylesheet" type="text/css" href="${0, _arrowCssDefault.default}"/>
    <my-navbar></my-navbar>
      
    <div id="header-container">
        <div id="header-container-left">
            <h1>Joshua Yang</h1>
            <p>
                Hello! I'm an undergraduate student at Brown University studying Computer Science and Applied Mathematics.
                I'm a fanatic of CGI, digital creator tools, and cross-country roadtrips. 
                You'll find me bouncing around the Brown Human-Computer Interaction Lab researching new forms of creativity support for artists.
                <div class="small-text">Contact me at joshua_yang (at) brown.edu!</div>
                <div class="small-text"><a href=${0, _resumeFall2024PdfDefault.default} target="_blank">Resume / CV</a></div>
            </p>
        </div>

        <div id="header-container-right">
            <img id="header-profile-picture-2" src="${0, _newPfpPngDefault.default}">
            <img id="header-profile-picture-1" src="${0, _profilePicture1JpgDefault.default}">
        </div>
    </div>

    <div class="pointer-container">
        <img class="arrow-down animated bounce" src="${0, _arrowDownSvgDefault.default}">
    </div>

    <h2 id="selected-research-header">Selected Research + Projects</h2>

    <item-portalink></item-portalink>
    <item-filtered-ink></item-filtered-ink>
    <item-procedural-paint></item-procedural-paint>

    <my-footer></my-footer>
    `;
    }
};
MyElement = __decorate([
    (0, _decoratorsJs.customElement)("index-page")
], MyElement);

},{"lit":"aCmte","lit/decorators.js":"kQrIl","./components/navbar.ts":"9SQ1S","./components/footer.ts":"fo7h0","./components/item.ts":"iQMSz","url:./assets/profile-picture-1.jpg":"gBGUk","url:./assets/new_pfp.png":"11dVd","url:./assets/resume_fall2024.pdf":"gGPHI","url:./assets/arrow_down.svg":"jBBOU","url:./style/arrow.css":"7I40S","./items-research/item-portalink.ts":"aEJPz","./items-research/item-filtered-ink.ts":"5bncE","./items-research/item-procedural-paint.ts":"egzT3","./style/global.ts":"7QH8W","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aCmte":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactiveElement = require("@lit/reactive-element");
var _litHtml = require("lit-html");
var _litElementJs = require("lit-element/lit-element.js");
parcelHelpers.exportAll(_litElementJs, exports);
var _isServerJs = require("lit-html/is-server.js");
parcelHelpers.exportAll(_isServerJs, exports);

},{"@lit/reactive-element":"hUcCl","lit-html":"4A25t","lit-element/lit-element.js":"8BOF1","lit-html/is-server.js":"2Mmwb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hUcCl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSResult", ()=>(0, _cssTagJs.CSSResult));
parcelHelpers.export(exports, "adoptStyles", ()=>(0, _cssTagJs.adoptStyles));
parcelHelpers.export(exports, "css", ()=>(0, _cssTagJs.css));
parcelHelpers.export(exports, "getCompatibleStyle", ()=>(0, _cssTagJs.getCompatibleStyle));
parcelHelpers.export(exports, "supportsAdoptingStyleSheets", ()=>(0, _cssTagJs.supportsAdoptingStyleSheets));
parcelHelpers.export(exports, "unsafeCSS", ()=>(0, _cssTagJs.unsafeCSS));
parcelHelpers.export(exports, "ReactiveElement", ()=>b);
parcelHelpers.export(exports, "defaultConverter", ()=>u);
parcelHelpers.export(exports, "notEqual", ()=>f);
var _cssTagJs = require("./css-tag.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: i, defineProperty: e, getOwnPropertyDescriptor: r, getOwnPropertyNames: h, getOwnPropertySymbols: o, getPrototypeOf: n } = Object, a = globalThis, c = a.trustedTypes, l = c ? c.emptyScript : "", p = a.reactiveElementPolyfillSupport, d = (t, s)=>t, u = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, f = (t, s)=>!i(t, s), y = {
    attribute: !0,
    type: String,
    converter: u,
    reflect: !1,
    hasChanged: f
};
Symbol.metadata ??= Symbol("metadata"), a.litPropertyMetadata ??= new WeakMap;
class b extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? y;
    }
    static _$Ei() {
        if (this.hasOwnProperty(d("elementProperties"))) return;
        const t = n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty(d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(d("properties"))) {
            const t = this.properties, s = [
                ...h(t),
                ...o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, _cssTagJs.getCompatibleStyle)(s));
        } else void 0 !== s && i.push((0, _cssTagJs.getCompatibleStyle)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, _cssTagJs.adoptStyles)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EC(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : u).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : u;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? f)(this[t], s)) return;
            this.P(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$ET());
    }
    P(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$ET() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.P(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EU();
        } catch (s) {
            throw t = !1, this._$EU(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EC(t, this[t])), this._$EU();
    }
    updated(t) {}
    firstUpdated(t) {}
}
b.elementStyles = [], b.shadowRootOptions = {
    mode: "open"
}, b[d("elementProperties")] = new Map, b[d("finalized")] = new Map, p?.({
    ReactiveElement: b
}), (a.reactiveElementVersions ??= []).push("2.0.4");

},{"./css-tag.js":"gSCbb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gSCbb":[function(require,module,exports) {
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSResult", ()=>n);
parcelHelpers.export(exports, "adoptStyles", ()=>S);
parcelHelpers.export(exports, "css", ()=>i);
parcelHelpers.export(exports, "getCompatibleStyle", ()=>c);
parcelHelpers.export(exports, "supportsAdoptingStyleSheets", ()=>e);
parcelHelpers.export(exports, "unsafeCSS", ()=>r);
const t = globalThis, e = t.ShadowRoot && (void 0 === t.ShadyCSS || t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, s = Symbol(), o = new WeakMap;
class n {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if (e && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const r = (t)=>new n("string" == typeof t ? t : t + "", void 0, s), i = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new n(o, t, s);
}, S = (s, o)=>{
    if (e) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, c = e ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return r(e);
    })(t) : t;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3151":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"4A25t":[function(require,module,exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_$LH", ()=>si);
parcelHelpers.export(exports, "html", ()=>ke);
parcelHelpers.export(exports, "mathml", ()=>Se);
parcelHelpers.export(exports, "noChange", ()=>R);
parcelHelpers.export(exports, "nothing", ()=>D);
parcelHelpers.export(exports, "render", ()=>Q);
parcelHelpers.export(exports, "svg", ()=>Oe);
const n = globalThis, c = n.trustedTypes, h = c ? c.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, f = "$lit$", v = `lit$${Math.random().toFixed(9).slice(2)}$`, m = "?" + v, _ = `<${m}>`, w = document, lt = ()=>w.createComment(""), st = (t)=>null === t || "object" != typeof t && "function" != typeof t, g = Array.isArray, $ = (t)=>g(t) || "function" == typeof t?.[Symbol.iterator], x = "[ 	\n\f\r]", T = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, E = /-->/g, k = />/g, O = RegExp(`>|${x}(?:([^\\s"'>=/]+)(${x}*=${x}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), S = /'/g, j = /"/g, M = /^(?:script|style|textarea|title)$/i, P = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), ke = P(1), Oe = P(2), Se = P(3), R = Symbol.for("lit-noChange"), D = Symbol.for("lit-nothing"), V = new WeakMap, I = w.createTreeWalker(w, 129);
function N(t, i) {
    if (!g(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== h ? h.createHTML(i) : i;
}
const U = (t, i)=>{
    const s = t.length - 1, e = [];
    let h, o = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", n = T;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let r, l, c = -1, a = 0;
        for(; a < s.length && (n.lastIndex = a, l = n.exec(s), null !== l);)a = n.lastIndex, n === T ? "!--" === l[1] ? n = E : void 0 !== l[1] ? n = k : void 0 !== l[2] ? (M.test(l[2]) && (h = RegExp("</" + l[2], "g")), n = O) : void 0 !== l[3] && (n = O) : n === O ? ">" === l[0] ? (n = h ?? T, c = -1) : void 0 === l[1] ? c = -2 : (c = n.lastIndex - l[2].length, r = l[1], n = void 0 === l[3] ? O : '"' === l[3] ? j : S) : n === j || n === S ? n = O : n === E || n === k ? n = T : (n = O, h = void 0);
        const u = n === O && t[i + 1].startsWith("/>") ? " " : "";
        o += n === T ? s + _ : c >= 0 ? (e.push(r), s.slice(0, c) + f + s.slice(c) + v + u) : s + v + (-2 === c ? i : u);
    }
    return [
        N(t, o + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
class B {
    constructor({ strings: t, _$litType$: i }, s){
        let e;
        this.parts = [];
        let h = 0, o = 0;
        const n = t.length - 1, r = this.parts, [l, a] = U(t, i);
        if (this.el = B.createElement(l, s), I.currentNode = this.el.content, 2 === i || 3 === i) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (e = I.nextNode()) && r.length < n;){
            if (1 === e.nodeType) {
                if (e.hasAttributes()) for (const t of e.getAttributeNames())if (t.endsWith(f)) {
                    const i = a[o++], s = e.getAttribute(t).split(v), n = /([.?@])?(.*)/.exec(i);
                    r.push({
                        type: 1,
                        index: h,
                        name: n[2],
                        strings: s,
                        ctor: "." === n[1] ? Y : "?" === n[1] ? Z : "@" === n[1] ? q : G
                    }), e.removeAttribute(t);
                } else t.startsWith(v) && (r.push({
                    type: 6,
                    index: h
                }), e.removeAttribute(t));
                if (M.test(e.tagName)) {
                    const t = e.textContent.split(v), i = t.length - 1;
                    if (i > 0) {
                        e.textContent = c ? c.emptyScript : "";
                        for(let s = 0; s < i; s++)e.append(t[s], lt()), I.nextNode(), r.push({
                            type: 2,
                            index: ++h
                        });
                        e.append(t[i], lt());
                    }
                }
            } else if (8 === e.nodeType) {
                if (e.data === m) r.push({
                    type: 2,
                    index: h
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = e.data.indexOf(v, t + 1));)r.push({
                        type: 7,
                        index: h
                    }), t += v.length - 1;
                }
            }
            h++;
        }
    }
    static createElement(t, i) {
        const s = w.createElement("template");
        return s.innerHTML = t, s;
    }
}
function z(t, i, s = t, e) {
    if (i === R) return i;
    let h = void 0 !== e ? s.o?.[e] : s.l;
    const o = st(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s.o ??= [])[e] = h : s.l = h), void 0 !== h && (i = z(t, h._$AS(t, i.values), h, e)), i;
}
class F {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? w).importNode(i, !0);
        I.currentNode = e;
        let h = I.nextNode(), o = 0, n = 0, r = s[0];
        for(; void 0 !== r;){
            if (o === r.index) {
                let i;
                2 === r.type ? i = new et(h, h.nextSibling, this, t) : 1 === r.type ? i = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i = new K(h, this, t)), this._$AV.push(i), r = s[++n];
            }
            o !== r?.index && (h = I.nextNode(), o++);
        }
        return I.currentNode = w, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class et {
    get _$AU() {
        return this._$AM?._$AU ?? this.v;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = D, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this.v = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = z(this, t, i), st(t) ? t === D || null == t || "" === t ? (this._$AH !== D && this._$AR(), this._$AH = D) : t !== this._$AH && t !== R && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== D && st(this._$AH) ? this._$AA.nextSibling.data = t : this.T(w.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = B.createElement(N(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new F(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = V.get(t.strings);
        return void 0 === i && V.set(t.strings, i = new B(t)), i;
    }
    k(t) {
        g(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new et(this.O(lt()), this.O(lt()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this.v = t, this._$AP?.(t));
    }
}
class G {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = D, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = D;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = z(this, t, i, 0), o = !st(t) || t !== this._$AH && t !== R, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = z(this, e[s + n], i, n), r === R && (r = this._$AH[n]), o ||= !st(r) || r !== this._$AH[n], r === D ? t = D : t !== D && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === D ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class Y extends G {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === D ? void 0 : t;
    }
}
class Z extends G {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== D);
    }
}
class q extends G {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = z(this, t, i, 0) ?? D) === R) return;
        const s = this._$AH, e = t === D && s !== D || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== D && (s === D || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class K {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        z(this, t);
    }
}
const si = {
    M: f,
    P: v,
    A: m,
    C: 1,
    L: U,
    R: F,
    D: $,
    V: z,
    I: et,
    H: G,
    N: Z,
    U: q,
    B: Y,
    F: K
}, Re = n.litHtmlPolyfillSupport;
Re?.(B, et), (n.litHtmlVersions ??= []).push("3.2.0");
const Q = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new et(i.insertBefore(lt(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8BOF1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LitElement", ()=>h);
parcelHelpers.export(exports, "_$LE", ()=>x);
var _reactiveElement = require("@lit/reactive-element");
parcelHelpers.exportAll(_reactiveElement, exports);
var _litHtml = require("lit-html");
parcelHelpers.exportAll(_litHtml, exports);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class h extends (0, _reactiveElement.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this.o = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const e = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this.o = (0, _litHtml.render)(e, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this.o?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.o?.setConnected(!1);
    }
    render() {
        return 0, _litHtml.noChange;
    }
}
h._$litElement$ = !0, h["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: h
});
const f = globalThis.litElementPolyfillSupport;
f?.({
    LitElement: h
});
const x = {
    _$AK: (t, e, s)=>{
        t._$AK(e, s);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.1.0");

},{"@lit/reactive-element":"hUcCl","lit-html":"4A25t","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Mmwb":[function(require,module,exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isServer", ()=>co);
const co = !1;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kQrIl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _customElementJs = require("@lit/reactive-element/decorators/custom-element.js");
parcelHelpers.exportAll(_customElementJs, exports);
var _propertyJs = require("@lit/reactive-element/decorators/property.js");
parcelHelpers.exportAll(_propertyJs, exports);
var _stateJs = require("@lit/reactive-element/decorators/state.js");
parcelHelpers.exportAll(_stateJs, exports);
var _eventOptionsJs = require("@lit/reactive-element/decorators/event-options.js");
parcelHelpers.exportAll(_eventOptionsJs, exports);
var _queryJs = require("@lit/reactive-element/decorators/query.js");
parcelHelpers.exportAll(_queryJs, exports);
var _queryAllJs = require("@lit/reactive-element/decorators/query-all.js");
parcelHelpers.exportAll(_queryAllJs, exports);
var _queryAsyncJs = require("@lit/reactive-element/decorators/query-async.js");
parcelHelpers.exportAll(_queryAsyncJs, exports);
var _queryAssignedElementsJs = require("@lit/reactive-element/decorators/query-assigned-elements.js");
parcelHelpers.exportAll(_queryAssignedElementsJs, exports);
var _queryAssignedNodesJs = require("@lit/reactive-element/decorators/query-assigned-nodes.js");
parcelHelpers.exportAll(_queryAssignedNodesJs, exports);

},{"@lit/reactive-element/decorators/custom-element.js":"dYoHp","@lit/reactive-element/decorators/property.js":"dggVt","@lit/reactive-element/decorators/state.js":"dJKtr","@lit/reactive-element/decorators/event-options.js":"9SENf","@lit/reactive-element/decorators/query.js":"12Pya","@lit/reactive-element/decorators/query-all.js":"gzvjw","@lit/reactive-element/decorators/query-async.js":"kZTrS","@lit/reactive-element/decorators/query-assigned-elements.js":"6ZZSg","@lit/reactive-element/decorators/query-assigned-nodes.js":"l1UPB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dYoHp":[function(require,module,exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "customElement", ()=>t);
const t = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dggVt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "property", ()=>n);
parcelHelpers.export(exports, "standardProperty", ()=>r);
var _reactiveElementJs = require("../reactive-element.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const o = {
    attribute: !0,
    type: String,
    converter: (0, _reactiveElementJs.defaultConverter),
    reflect: !1,
    hasChanged: (0, _reactiveElementJs.notEqual)
}, r = (t = o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.P(o, void 0, t), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function n(t) {
    return (e, o)=>"object" == typeof o ? r(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, r ? {
                ...t,
                wrapped: !0
            } : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}

},{"../reactive-element.js":"hUcCl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dJKtr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "state", ()=>r);
var _propertyJs = require("./property.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function r(r) {
    return (0, _propertyJs.property)({
        ...r,
        state: !0,
        attribute: !1
    });
}

},{"./property.js":"dggVt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9SENf":[function(require,module,exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventOptions", ()=>t);
function t(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"12Pya":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "query", ()=>e);
var _baseJs = require("./base.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function e(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, _baseJs.desc)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, _baseJs.desc)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}

},{"./base.js":"f4sFH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f4sFH":[function(require,module,exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "desc", ()=>e);
const e = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gzvjw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queryAll", ()=>r);
var _baseJs = require("./base.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let e;
function r(r) {
    return (n, o)=>(0, _baseJs.desc)(n, o, {
            get () {
                return (this.renderRoot ?? (e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}

},{"./base.js":"f4sFH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kZTrS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queryAsync", ()=>r);
var _baseJs = require("./base.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function r(r) {
    return (n, e)=>(0, _baseJs.desc)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}

},{"./base.js":"f4sFH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6ZZSg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queryAssignedElements", ()=>o);
var _baseJs = require("./base.js");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function o(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, _baseJs.desc)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}

},{"./base.js":"f4sFH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l1UPB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queryAssignedNodes", ()=>n);
var _baseJs = require("./base.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function n(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, _baseJs.desc)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}

},{"./base.js":"f4sFH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9SQ1S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MyNavbar", ()=>MyNavbar);
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _globalTs = require("../style/global.ts");
var _indexTs = require("../index.ts");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let MyNavbar = class MyNavbar extends (0, _lit.LitElement) {
    static get styles() {
        return [
            (0, _globalTs.GlobalCSS),
            (0, _lit.css)`:host {
            width: 100%;
        }
        
        nav {
            width: fit-content;
            margin-left: auto;
            margin-right: 4rem;
            
            margin-top: 2rem;
            margin-bottom: 4rem;
        }

        nav a {
            font-family: system-ui;
            font-size: 16pt;
            
            color: black;
            text-decoration: none;
            cursor: pointer;

            margin-left: 1rem;
            margin-right: 1rem;
        }
    `
        ];
    }
    render() {
        return (0, _lit.html)`
        <nav>
            <a href="${0, _indexTs.relative_root}/index.html">About</a>
            <a href="${0, _indexTs.relative_root}/pages/research.html">Research</a>
            <a href="${0, _indexTs.relative_root}/pages/projects.html">Projects</a>
            <!-- <a href="/pages/blog.html">Blog</a> -->
            <!-- <a href="${0, _indexTs.relative_root}/pages/artwork.html">Artwork</a>  -->
        </nav>`;
    }
};
MyNavbar = __decorate([
    (0, _decoratorsJs.customElement)("my-navbar")
], MyNavbar);

},{"lit":"aCmte","lit/decorators.js":"kQrIl","../style/global.ts":"7QH8W","../index.ts":"8RSWf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7QH8W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GlobalCSS", ()=>GlobalCSS);
var _lit = require("lit");
const GlobalCSS = (0, _lit.unsafeCSS)(`
h1 {
    font-family: MainFont, system-ui;
    font-size: 48pt;

    margin-top: 1rem;
    margin-bottom: 1rem;
}

h2 {
    font-family: MainFont, system-ui;
    font-size: 32pt;
}

h3 {
    font-family: MainFont, system-ui;
    font-size: 24pt;
}

h4 {
    font-family: MainFont, system-ui;
    font-size: 16pt;
}

p {
    font-family: MainFontLight, system-ui;
    font-size: 14pt;
}

a {
    font-family: MainFontLight, system-ui;
    font-size: 14pt;
}

.small-text {
    font-family: MainFontLight, system-ui;
    font-size: 11pt;
}

`);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fo7h0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MyFooter", ()=>MyFooter);
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _globalTs = require("../style/global.ts");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let MyFooter = class MyFooter extends (0, _lit.LitElement) {
    static get styles() {
        return [
            (0, _globalTs.GlobalCSS),
            (0, _lit.css)`:host {
            margin-top: 4rem;
            margin-bottom: 1rem;
        }
    `
        ];
    }
    render() {
        return (0, _lit.html)`
        <p>Designed and built with &#127912; by Josh Yang</p>
        `;
    }
};
MyFooter = __decorate([
    (0, _decoratorsJs.customElement)("my-footer")
], MyFooter);

},{"lit":"aCmte","lit/decorators.js":"kQrIl","../style/global.ts":"7QH8W","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iQMSz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MyItem", ()=>MyItem);
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _globalTs = require("../style/global.ts");
var _itemImgStyleTs = require("../style/item-img-style.ts");
var _unsafeHtmlJs = require("lit/directives/unsafe-html.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let MyItem = class MyItem extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this.title = "";
        this.date = "";
        this.description = "";
        this.check_it_out_link = "";
        this.custom_check_it_out_writing = "";
        this.read_more_link = "";
        this.alt_picture_src_href = "";
        this.picture_src_href = "";
        this.under_construction = false;
    }
    static get styles() {
        return [
            (0, _globalTs.GlobalCSS),
            (0, _lit.css)`:host {

        }

        .item-container {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 4rem;
        }
        
        .item-container-left {
            display: flex;
            flex-direction: column;
        
            margin-right: 4rem;
        }
        
        .item-container-right {
            display: flex;
            flex-direction: column;

            width: 32rem;
        }

        .item-img-container {
            width: 16rem;
            height: 16rem;

            border: 1.5px solid black;
            overflow: hidden;
            display: flex;
            position: relative;
        }

        .item-snippet-small-screen {
            display: none;
        }

        .item-container h3 {
            font-family: MainFont, system-ui;
            font-size: 24pt;

            margin-top: 0;
            margin-bottom: 0;
        }

        .item-container h4 {
            font-family: MainFont, system-ui;
            font-size: 16pt;

            margin-top: 0;
            margin-bottom: 0;
        }

        .img-above {
            position: absolute !important;
            z-index: 100;
        }

        .img-below {
            position: absolute !important;
            z-index: 0;
        }
    `
        ];
    }
    render() {
        return (0, _lit.html)`
        <div class="item-container">
            <div class="item-container-left">
                <div class="item-img-container">
                    ${this.alt_picture_src_href !== "" ? (0, _lit.html)`<img class="img-below" id=${this.title} style=${(0, _itemImgStyleTs.item_image_css)[this.title]} src="${this.alt_picture_src_href}">` : ""}
                    <img class="img-above" id=${this.title} style=${(0, _itemImgStyleTs.item_image_css)[this.title]} src="${this.picture_src_href}">
                </div>
            </div>
            
            <div class="item-container-right">
                <h3>${this.title}</h3>
                <h4>${this.date}</h4>
                <p>${(0, _unsafeHtmlJs.unsafeHTML)(this.description)}</p>
                ${this.check_it_out_link !== "" ? (0, _lit.html)`<a class="item-check-it-out" href="${this.check_it_out_link}" target="_blank">${this.custom_check_it_out_writing !== "" ? this.custom_check_it_out_writing : "Check it out"} &#8594;</a>` : ""}
                ${this.read_more_link !== "" ? (0, _lit.html)`<a class="item-check-it-out" href="${this.read_more_link}">Read more &#8594;</a>` : ""}
                ${this.under_construction ? (0, _lit.html)`<a class="item-check-it-out" href="">Project page under construction &#x1f6a7;</a>` : ""}
            </div>
        </div>
        `;
    }
};
__decorate([
    (0, _decoratorsJs.property)({
        type: "String"
    })
], MyItem.prototype, "title", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: "String"
    })
], MyItem.prototype, "date", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: "String"
    })
], MyItem.prototype, "description", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: "String"
    })
], MyItem.prototype, "check_it_out_link", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: "String"
    })
], MyItem.prototype, "custom_check_it_out_writing", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: "String"
    })
], MyItem.prototype, "read_more_link", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: "String"
    })
], MyItem.prototype, "alt_picture_src_href", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: "String"
    })
], MyItem.prototype, "picture_src_href", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: "Boolean"
    })
], MyItem.prototype, "under_construction", void 0);
MyItem = __decorate([
    (0, _decoratorsJs.customElement)("my-item")
], MyItem);

},{"lit":"aCmte","lit/decorators.js":"kQrIl","../style/global.ts":"7QH8W","../style/item-img-style.ts":"9jMoh","lit/directives/unsafe-html.js":"gPTqb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9jMoh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "item_image_css", ()=>item_image_css);
var _lit = require("lit");
const item_image_css = {
    // ###################
    // PROJECT ITEMS CSS
    // ###################
    "ReSTIR Path Tracing": (0, _lit.css)`
        width: 100%;
        filter: brightness(2.5);`,
    "Geometry Processing": (0, _lit.css)`
        width: 100%;
        filter: brightness(1.5);`,
    "Path Tracing": (0, _lit.css)`
        width: 100%;
        filter: brightness(1.5);`,
    "Reaction-Diffusion Simulation": (0, _lit.css)`
        filter: brightness(1.5);`,
    "Cloud Volume Rendering": (0, _lit.css)`
        position: relative;
        height: 16rem;
        left: -10rem;`,
    "Conformal Map Viewer": (0, _lit.css)`
        position: relative;
        height: 16rem;`,
    "Hello Munchkins": (0, _lit.css)`
        position: relative;
        width: 24rem;
        left: -4.1rem;`,
    "Color.io": (0, _lit.css)`
        position: relative;
        height: 16rem;`,
    // ###################
    // RESEARCH ITEMS CSS
    // ###################
    "filtered.ink": (0, _lit.css)`
        filter: saturate(1.3);
        position: relative;
        width: 30rem;
        left: -8rem;`,
    "PortalInk": (0, _lit.css)`
        width: 100%;
        height: 100%;`,
    "Procedural 3D Paint": (0, _lit.css)`
        filter: saturate(1.3);
        position: relative;
        width: 25rem;
        left: -4rem;
        top: -1rem;`
};

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gPTqb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _unsafeHtmlJs = require("lit-html/directives/unsafe-html.js");
parcelHelpers.exportAll(_unsafeHtmlJs, exports);

},{"lit-html/directives/unsafe-html.js":"4DFR8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4DFR8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnsafeHTMLDirective", ()=>le);
parcelHelpers.export(exports, "unsafeHTML", ()=>ae);
var _litHtmlJs = require("../lit-html.js");
var _directiveJs = require("../directive.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class le extends (0, _directiveJs.Directive) {
    constructor(i){
        if (super(i), this.it = (0, _litHtmlJs.nothing), i.type !== (0, _directiveJs.PartType).CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
    }
    render(t) {
        if (t === (0, _litHtmlJs.nothing) || null == t) return this._t = void 0, this.it = t;
        if (t === (0, _litHtmlJs.noChange)) return t;
        if ("string" != typeof t) throw Error(this.constructor.directiveName + "() called with a non-string value");
        if (t === this.it) return this._t;
        this.it = t;
        const i = [
            t
        ];
        return i.raw = i, this._t = {
            _$litType$: this.constructor.resultType,
            strings: i,
            values: []
        };
    }
}
le.directiveName = "unsafeHTML", le.resultType = 1;
const ae = (0, _directiveJs.directive)(le);

},{"../lit-html.js":"4A25t","../directive.js":"k6ssg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k6ssg":[function(require,module,exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Directive", ()=>i);
parcelHelpers.export(exports, "PartType", ()=>t);
parcelHelpers.export(exports, "directive", ()=>e);
const t = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, e = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class i {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this.t = t, this._$AM = e, this.i = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gBGUk":[function(require,module,exports) {
module.exports = require("a021709e8cd91891").getBundleURL("dgt5F") + "profile-picture-1.7495cca9.jpg";

},{"a021709e8cd91891":"c7Tr5"}],"11dVd":[function(require,module,exports) {
module.exports = require("32acf38c4d3a9ca3").getBundleURL("dgt5F") + "new_pfp.f412a206.png";

},{"32acf38c4d3a9ca3":"c7Tr5"}],"gGPHI":[function(require,module,exports) {
module.exports = require("ea775df83f876f2e").getBundleURL("dgt5F") + "resume_fall2024.2350a0e2.pdf";

},{"ea775df83f876f2e":"c7Tr5"}],"jBBOU":[function(require,module,exports) {
module.exports = require("39f3a20afbb3b7d0").getBundleURL("dgt5F") + "arrow_down.fbe43fd1.svg";

},{"39f3a20afbb3b7d0":"c7Tr5"}],"7I40S":[function(require,module,exports) {
module.exports = require("faa66b0228968395").getBundleURL("dgt5F") + "arrow.6881dd4b.css";

},{"faa66b0228968395":"c7Tr5"}],"aEJPz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ItemPortalInk", ()=>ItemPortalInk);
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _globalTs = require("../style/global.ts");
var _itemTs = require("../components/item.ts");
// @ts-ignore
var _portalinkSolarSystemExamplePng = require("../assets/portalink_solar_system_example.png");
var _portalinkSolarSystemExamplePngDefault = parcelHelpers.interopDefault(_portalinkSolarSystemExamplePng);
// @ts-ignore
var _portalinkGif = require("../assets/portalink.gif");
var _portalinkGifDefault = parcelHelpers.interopDefault(_portalinkGif);
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let ItemPortalInk = class ItemPortalInk extends (0, _lit.LitElement) {
    static get styles() {
        return [
            (0, _globalTs.GlobalCSS),
            (0, _lit.css)`:host {

        }
    `
        ];
    }
    render() {
        return (0, _lit.html)`
        <my-item
            title="PortalInk"
            date="fall 2023 - summer 2024"
            description="Extending filtered.ink for 2.5D visual storytelling in vector graphics. 
            Enabling artists to craft 2.5D experiences while maintaining traditional
            2D workflows through SVG transitions and portals. <br> Led to 1 publication at UIST '24."
            check_it_out_link="https://filtered.ink/#/"
            alt_picture_src_href="${0, _portalinkSolarSystemExamplePngDefault.default}"
            picture_src_href="${0, _portalinkGifDefault.default}"></my-item>`;
    }
};
ItemPortalInk = __decorate([
    (0, _decoratorsJs.customElement)("item-portalink")
], ItemPortalInk);

},{"lit":"aCmte","lit/decorators.js":"kQrIl","../style/global.ts":"7QH8W","../components/item.ts":"iQMSz","../assets/portalink_solar_system_example.png":"dC4IP","../assets/portalink.gif":"1lGM4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dC4IP":[function(require,module,exports) {
module.exports = require("394575ff2f73ef4f").getBundleURL("dgt5F") + "portalink_solar_system_example.2cd6b5b4.png";

},{"394575ff2f73ef4f":"c7Tr5"}],"1lGM4":[function(require,module,exports) {
module.exports = require("a556770d4c37a213").getBundleURL("dgt5F") + "portalink.b7627d08.gif";

},{"a556770d4c37a213":"c7Tr5"}],"5bncE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ItemFilteredInk", ()=>ItemFilteredInk);
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _globalTs = require("../style/global.ts");
var _itemTs = require("../components/item.ts");
// @ts-ignore
var _villageGifGif = require("../assets/village-gif.gif");
var _villageGifGifDefault = parcelHelpers.interopDefault(_villageGifGif);
// @ts-ignore
var _villagePng = require("../assets/village.png");
var _villagePngDefault = parcelHelpers.interopDefault(_villagePng);
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let ItemFilteredInk = class ItemFilteredInk extends (0, _lit.LitElement) {
    static get styles() {
        return [
            (0, _globalTs.GlobalCSS),
            (0, _lit.css)`:host {

        }
    `
        ];
    }
    render() {
        return (0, _lit.html)`
        <my-item
            title="filtered.ink"
            date="spring 2022 - fall 2023"
            description="A complete, web-based illustration system for vector graphics. 
            Augmenting artist users with dynamic textures and animated patterns 
            for novel stylization in the vector format. <br> Led to 2 publications at CHI '23."
            check_it_out_link="https://filtered.ink/#/"
            alt_picture_src_href="${0, _villagePngDefault.default}"
            picture_src_href="${0, _villageGifGifDefault.default}"></my-item>`;
    // read_more_link="https://the3dsquare.com/project-pages/filteredink.html"
    }
};
ItemFilteredInk = __decorate([
    (0, _decoratorsJs.customElement)("item-filtered-ink")
], ItemFilteredInk);

},{"lit":"aCmte","lit/decorators.js":"kQrIl","../style/global.ts":"7QH8W","../components/item.ts":"iQMSz","../assets/village-gif.gif":"ic5Gy","../assets/village.png":"d8ISv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ic5Gy":[function(require,module,exports) {
module.exports = require("ea60faff456ce1a7").getBundleURL("dgt5F") + "village-gif.5abbfea4.gif";

},{"ea60faff456ce1a7":"c7Tr5"}],"d8ISv":[function(require,module,exports) {
module.exports = require("ff5c64d274634c1").getBundleURL("dgt5F") + "village.befd9f6b.png";

},{"ff5c64d274634c1":"c7Tr5"}],"egzT3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ItemProceduralPaint", ()=>ItemProceduralPaint);
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _globalTs = require("../style/global.ts");
var _itemTs = require("../components/item.ts");
// @ts-ignore
var _paintedCubePng = require("../assets/painted-cube.png");
var _paintedCubePngDefault = parcelHelpers.interopDefault(_paintedCubePng);
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let ItemProceduralPaint = class ItemProceduralPaint extends (0, _lit.LitElement) {
    static get styles() {
        return [
            (0, _globalTs.GlobalCSS),
            (0, _lit.css)`:host {

        }
    `
        ];
    }
    render() {
        return (0, _lit.html)`
        <my-item
            title="Procedural 3D Paint"
            date="winter 2021 - spring 2022"
            description="A custom brush engine for painterly texture generation with 3D models. Helping artists paint light on textures in 3D with global illumination."
            read_more_link="https://the3dsquare.com/project-pages/procedural-paint.html"
            picture_src_href="${0, _paintedCubePngDefault.default}"></my-item>`;
    }
};
ItemProceduralPaint = __decorate([
    (0, _decoratorsJs.customElement)("item-procedural-paint")
], ItemProceduralPaint);

},{"lit":"aCmte","lit/decorators.js":"kQrIl","../style/global.ts":"7QH8W","../components/item.ts":"iQMSz","../assets/painted-cube.png":"dmr4e","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dmr4e":[function(require,module,exports) {
module.exports = require("7d4c0f1a9d84c2d5").getBundleURL("dgt5F") + "painted-cube.1c2d5e2f.png";

},{"7d4c0f1a9d84c2d5":"c7Tr5"}]},["bkC94","8RSWf"], "8RSWf", "parcelRequireb742")

//# sourceMappingURL=index.db3ace4e.js.map
